import Repository from "./repository"

export default {
    /**
     * S21302_変更内容確認
     *
     * @param {object} params リクエストパラメータ
     */
    check(params) {
        return Repository.post('/api/s213-contract-changes/check', params)
    },
    /**
     * S21303_変更内容更新処理
     *
     * @param {object} params リクエストパラメータ
     */
    add(params) {
        return Repository.post('/api/s213-contract-changes/add', params)
    },
    /**
     * S21304_プラン変更確認処理
     *
     * @param {object} params リクエストパラメータ
     */
    checkPlan(params) {
        return Repository.post('/api/s213-contract-changes/plan/check', params)
    },
    /**
     * S21305_プラン変更処理
     *
     * @param {object} params リクエストパラメータ
     */
    addPlan(params) {
        return Repository.post('/api/s213-contract-changes/plan/add', params)
    },
}
